export const reCharacteristicConstants = {
	GetList: {
		FAILURE : 'GET_LIST_CHARACTERISTIC_FAILURE',
		REQUEST : 'GET_LIST_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_LIST_CHARACTERISTIC_SUCCESS'
	},
	GetPaged: {
		SUCCESS : 'GET_PAGED_CHARACTERISTIC_SUCCESS',
		REQUEST : 'GET_PAGED_CHARACTERISTIC_REQUEST',
		FAILURE : 'GET_PAGED_CHARACTERISTIC_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_CHARACTERISTIC_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_CHARACTERISTIC_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_CHARACTERISTIC_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'CREATE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'CREATE_CHARACTERISTIC_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'DELETE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'DELETE_CHARACTERISTIC_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'UPDATE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'UPDATE_CHARACTERISTIC_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_CHARACTERISTIC_REQUEST',
		SUCCESS : 'RESTORE_CHARACTERISTIC_SUCCESS',
		FAILURE : 'RESTORE_CHARACTERISTIC_FAILURE'
	},
	Clear: 'CLEAR_CHARACTERISTIC'
}